/** Synchronous and independent of connectivity; runs before any router/map reader. */
export const purgeLegacyGeocode = () => {
  try { localStorage.removeItem('sb.geo.v1'); } catch { /* blocked storage is not readable either */ }
};
export const installGeocodePurge = () => {
  purgeLegacyGeocode();
  window.addEventListener('pageshow', purgeLegacyGeocode);
  document.addEventListener('visibilitychange', purgeLegacyGeocode);
};
